import { render, staticRenderFns } from "./ProfilePhotoComponent.vue?vue&type=template&id=3400d7f2&"
import script from "./ProfilePhotoComponent.vue?vue&type=script&lang=ts&"
export * from "./ProfilePhotoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3400d7f2')) {
      api.createRecord('3400d7f2', component.options)
    } else {
      api.reload('3400d7f2', component.options)
    }
    module.hot.accept("./ProfilePhotoComponent.vue?vue&type=template&id=3400d7f2&", function () {
      api.rerender('3400d7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Applicant/ProfilePhotoComponent.vue"
export default component.exports